import { BRAND_COPYRIGHT } from "./brand";

export function InflowFooter() {
  return (
    <footer className="border-t border-border px-5 pt-8 pb-12 sm:py-10">
      <div className="mx-auto max-w-3xl space-y-3 text-center text-[8px] leading-snug text-muted-foreground sm:text-xs">
        <p className="font-medium text-foreground">{BRAND_COPYRIGHT}</p>
        <p>
          DISCLAIMER: Individual results may vary. The figures stated above are our client's REAL
          figures. Please understand our results are not typical. We are not implying you'll
          duplicate them.
        </p>
        <p>
          Your results will vary and depend on many factors including but not limited to your
          background, experience, sales ability, and work ethic. All partnerships require risk as
          well as massive and consistent effort and action. If you're not willing to accept that,
          please DO NOT opt in.
        </p>
      </div>
    </footer>
  );
}
